<template>
    <div class="core-radio">
        <RadioButton
            v-model="selected"
            :name="name"
            :value="optionValue"
            :inputId="`${id}-${optionValue}`"
            class="core-radio"
            :disabled="disabled"
        />
        <span class="core-radio__label">{{ displayLabel }}</span>
    </div>
</template>

<script>
import RadioButton from 'primevue/radiobutton'

export default {
    name: 'CoreRadio',

    components: { RadioButton },

    props: {
        modelValue: {
            type: [String, Number],
            default: null,
        },

        label: {
            type: [String, Number],
            required: true,
        },

        name: {
            type: [String, Number],
            required: true,
        },

        id: {
            type: [String, Number],
            required: true,
        },

        optionValue: {
            type: [String, Number],
            required: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:modelValue'],

    computed: {
        selected: {
            get() {
                return this.modelValue
            },

            set(newValue) {
                this.$emit('update:modelValue', newValue)
            },
        },

        displayLabel() {
            return this.$t(this.label)
        },
    },
}
</script>

<style>
.core-radio {
    display: flex;
    align-items: center;
    cursor: default;

    & .core-radio__label {
        margin-left: 8px;
    }

    &.p-radiobutton.p-disabled .p-radiobutton-box {
        background-color: var(--color-disabled-bg);
        cursor: not-allowed;
    }
}
</style>
